import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import ComponentSkeleton from '../../components/skeleton'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faFilter, faMoneyBill, faShare, faPrint, faFileAlt } from '@fortawesome/free-solid-svg-icons'
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import { NOME_EMPRESA } from '../../config'
import { confirmAlert } from 'react-confirm-alert'
import { PDFExport } from "@progress/kendo-react-pdf";
import 'react-confirm-alert/src/react-confirm-alert.css'
import Footer from '../../components/footer'
import PdfVoucher from '../../components/pdfVoucher'
import Alert from '../../components/alert';
import moment from 'moment'
import ModalHistorico from '../../components/modalHistorico'

const estadoInicial = {
    name: '',
    vouchers: [],
    loading: false,
    loadingPesquisa: false,
    redirect: false,

    pdfGerado: '',
    pdfNome: '',

    usuariosOptions: [],
    usuario: '',
    unidadesOptions: [],
    unidade: '',
    produtosOptions: [],
    produto: '',

    textoOptions: '',

    pesquisa: '',
    tipoPesquisa: 0,

    loading: true,
    alert: { type: '', msg: '' },

    lancamentos: [],
    historicosModal: false,

    dataCancelamentoComeco: moment().isAfter(moment().set('hour', 10).set('minute', 0)) ? moment().set('hour', 14).set('minute', 30) : moment().set('hour', 1).set('minute', 0),
    dataCancelamentoFim: moment().isAfter(moment().set('hour', 10).set('minute', 0)) ? moment().set('hour', 18).set('minute', 0) : moment().set('hour', 10).set('minute', 0),
    podeCancelar: false,

    empresaNome:'',
}

class Vouchers extends Component {

    constructor(props) {
        super(props);
        this.pdfExportComponent = React.createRef(null);
    }
    state = {
        ...estadoInicial
    }

    componentDidMount = () => {
        this.getVouchers();

        this.getOptions();

        this.setState({
            podeCancelar: moment().isAfter(this.state.dataCancelamentoComeco) && moment().isBefore(this.state.dataCancelamentoFim),
            loading: false
        });
    }

    getVouchers = async () => {
        if (this.props.id === 999999) {
            apiEmployee.get(`/vouchers/getvouchers/${localStorage.getItem('empresaID')}`)
                .then(res => {
                    this.setState({
                        vouchers: res.data,
                        empresaNome: res.data[0].empresaNome,
                    });
                })
        } else {
            apiEmployee.get(`/vouchers/getvouchers/${localStorage.getItem('empresaID')}`)
                .then(res => this.setState({
                    vouchers: res.data
                }))
        }
    }

    getOptions = async () => {
        const unidadesOptions = await apiEmployee.get(`pegarunidades/creditos/${this.props.id}`).then(res => res.data).catch(err => []);
        const usuariosOptions = await apiEmployee.get(`tickets/pegarusuarios/${this.props.id}`).then(res => res.data).catch(err => []);

        await this.setState({
            unidadesOptions: [{ label: '---', value: '' }, ...unidadesOptions.map((s) => ({ label: s.Nome, value: s.Chave }))],
            usuariosOptions: [{ label: '---', value: '' }, ...usuariosOptions.map((s) => ({ label: s.nome, value: s.chave }))],
        })
    }

    cancelVoucher = (id, nome) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>{NOME_EMPRESA}</h1>
                        <div>
                            <span>Deseja cancelar este voucher? (de {nome})</span>
                        </div>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-danger w-25"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Não
                        </button>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-25"
                            onClick={
                                async () => {
                                    await apiEmployee.delete(`vouchers/apagar/${id}`).then(
                                        async response => {
                                            if (response.data === true) {
                                                document.location.reload()
                                            }
                                        },
                                        async response => {
                                            this.erroApi(response)
                                        }
                                    )
                                    onClose()
                                }
                            }

                        >
                            Sim
                        </button>
                    </div>
                )
            }
        })
    }

    filterItems = (item) => {
        return true
    }


    shareVoucher = async (voucher, quantity = 1) => {
        let pdfNome;
        if (voucher.tipo == "USUARIO") {
            pdfNome = `VOUCHER - ${voucher.produtoNome}${` DE ${voucher.pessoaNome}`}`;
        } else {
            pdfNome = `VOUCHERS - ${voucher.produtoNome} (${voucher.unidadeNome})`
        }

        const pdf = <PdfVoucher voucher={voucher} quantity={quantity} />

        await this.setState({ pdfGerado: pdf, pdfNome, loading: false });
        const url = `https://wa.me/send?phone=${voucher.pessoaTelefone}`;

        await this.printPdf()
        const link = document.createElement("a");
        link.href = url;
        link.target = '_blank';
        link.click();
    }

    handlePrint = async (voucher, type = 'IMPRESSAO') => {
        this.setState({ loading: true })
        if (voucher?.tipo == "USUARIO") {
            if (type == "IMPRESSAO") {
                return this.printVoucher(voucher);
            } else if (type == "COMPARTILHAMENTO") {
                return this.shareVoucher(voucher);
            }
            this.setState({ loading: false })
        } else {
            const quantity = Math.round(voucher.saldo / voucher.preco);

            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className='custom-ui text-center'>
                            <h1>{NOME_EMPRESA}</h1>
                            <div>
                                <span>Deseja imprimir {quantity} vouchers?</span>
                            </div>
                            <button
                                style={{ marginRight: 5 }}
                                className="btn btn-danger w-25"
                                onClick={
                                    async () => {
                                        onClose()
                                        return this.setState({ loading: false });
                                    }
                                }
                            >
                                Não
                            </button>
                            <button
                                style={{ marginRight: 5 }}
                                className="btn btn-success w-25"
                                onClick={
                                    async () => {
                                        onClose()
                                        if (type == "IMPRESSAO") {
                                            return this.printVoucher(voucher, quantity);
                                        } else if (type == "COMPARTILHAMENTO") {
                                            return this.shareVoucher(voucher, quantity);
                                        }
                                    }
                                }

                            >
                                Sim
                            </button>
                        </div>
                    )
                }
            })
        }
    }

    pegarLancamentos = async (voucher) => {
        await apiEmployee.get(`/vouchers/lancamentos/${voucher}`)
            .then(res => this.setState({
                lancamentos: res.data,
                historicosModal: true,
            }),
                err => console.error(err)
            ).catch(err => console.error(err))
    }

    printVoucher = async (voucher, quantity = 1) => {
        let pdfNome;
        if (voucher.tipo == "USUARIO") {
            pdfNome = `VOUCHER - ${voucher.produtoNome}${` DE ${voucher.pessoaNome}`}`;
        } else {
            pdfNome = `VOUCHERS - ${voucher.produtoNome} (${voucher.unidadeNome})`
        }

        const pdf = <PdfVoucher voucher={voucher} quantity={quantity} />

        await this.setState({ pdfGerado: pdf, pdfNome, loading: false });
        this.printPdf();
    }

    printPdf = () => {
        this.pdfExportComponent.current.save();
    }

    filterItems = (item) => {
        if (this.state.unidade && item.chave_unidade != this.state.unidade) {
            return false;
        }

        if (this.state.usuario && item.chave_usuario != this.state.usuario) {
            return false;
        }

        if (item.cancelado !== 0) {
            return false;
        }

        return true;
    }

    render() {
        if (this.state.loading) {
            return (<ComponentSkeleton />)
        }

        return (
            <div className='page page-list'>
                <div
                    style={{
                        position: "absolute",
                        left: "-900000px",
                        top: 0,
                    }}
                >
                    <PDFExport
                        fileName={this.state.pdfNome}
                        scale={0.6}
                        landscape={false}
                        className={"pdfExp"}
                        paperSize="A4"
                        margin="0.5cm"
                        forcePageBreak=".page-break"
                        ref={this.pdfExportComponent}>
                        {this.state.pdfGerado}
                    </PDFExport>
                </div>
                {this.state.redirect &&
                    <Redirect to={'/'} />
                }


                <Alert
                    alert={this.state.alert}
                    setAlert={(value) => this.setState({ alert: value })}
                />

                {!this.state.loading &&
                    <div>
                        <ModalHistorico
                            lancamentos={this.state.lancamentos}
                            voucher
                            open={this.state.historicosModal}
                            onClose={(e) => this.setState({ historicosModal: e })}
                        />

                        <section>
                            <Header voltar />

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="page-breadcrumb">
                                        <h2 id='titulo'>Vouchers</h2>
                                    </div>
                                </div>
                            </div>

                        </section>

                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>

                            <Link to={{
                                pathname: `/addvoucher/0`,
                                state: { os: undefined }
                            }} className='butaoadicionarcardapio add_button_big'>Criar voucher</Link>

                            <div className='butaofiltros change_margin_mobile' onClick={(a) => this.setState({ expandido: !this.state.expandido })}> Filtrar  <FontAwesomeIcon icon={faFilter} size="12" color='black' /> </div>

                        </div>

                        <div className='add_button_fab'>
                            <Link to={{
                                pathname: `/addvoucher/0`,
                                state: { voucher: undefined }
                            }}>
                                +
                            </Link>
                        </div>

                        {this.state.expandido &&
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: 10 }}>
                                <div className='col-8' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-evenly' }}>
                                    <div className='filter-field col-6 '>
                                        <span>Unidade:</span>
                                        <select className='select-filtro' value={this.state.unidade} onChange={(e) => this.setState({ unidade: e.currentTarget.value })}>
                                            {this.state.unidadesOptions.map((opt) => (
                                                <option value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='filter-field col-6'>
                                        <span>Usuário:</span>
                                        <select className='select-filtro' value={this.state.usuario} onChange={(e) => this.setState({ usuario: e.currentTarget.value })}>
                                            {this.state.usuariosOptions.map((opt) => (
                                                <option value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        }

                        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div className='col-12 row tickets_div'>
                                {this.state.vouchers.filter(this.filterItems).map((voucher, index) => {

                                    return (
                                        <div className='ticket_wrapper' key={voucher.chave}>
                                            <div className='ticket_header'>
                                                <div className='ticket_titulos' style={{ flexGrow: 2 }}>
                                                    <div className='ticket_titulos_empresa'>{voucher.unidadeNome}</div>
                                                    <div className='ticket_titulos_unidade'>{voucher.pessoaNome}</div>
                                                </div>
                                                <div className='ticket_titulos' style={{ flexGrow: 1 }}>
                                                    <div className='ticket_titulos_data'>{voucher.produtoNome}</div>
                                                    <div className='ticket_titulos_saldo'>
                                                        <span style={{ whiteSpace: 'nowrap' }}>
                                                            R$ {new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(voucher.saldo)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr className='ticket_divider' />
                                            <div className='ticket_footer'>
                                                <div className='ticket_footer_buttons'>
                                                    <div className='ticket_footer_button'>
                                                        <Link to={{
                                                            pathname: `/addvoucher/${voucher.chave}`,
                                                            state: { voucher: { ...voucher } }
                                                        }}>
                                                            <FontAwesomeIcon
                                                                title="Recarregar"
                                                                icon={faMoneyBill}
                                                                color={"#DE3338"}
                                                                size={40} />
                                                        </Link>
                                                    </div>
                                                    <div className='ticket_footer_button'>
                                                        <FontAwesomeIcon
                                                            title='Histórico'
                                                            icon={faFileAlt}
                                                            color={"#DE3338"}
                                                            size={40}
                                                            onClick={() => this.pegarLancamentos(voucher.chave)}
                                                        />
                                                    </div>
                                                    <div className='ticket_footer_button'>
                                                        <FontAwesomeIcon
                                                            title="Imprimir"
                                                            icon={faPrint}
                                                            color={"#DE3338"}
                                                            onClick={() => this.handlePrint(voucher, "IMPRESSAO")}
                                                            size={40} />
                                                    </div>
                                                    {voucher.tipo === "USUARIO" &&
                                                        <div className='ticket_footer_button'>
                                                            <FontAwesomeIcon
                                                                title="Compartilhar"
                                                                icon={faShare}
                                                                color={"#DE3338"}
                                                                onClick={() => this.handlePrint(voucher, "COMPARTILHAMENTO")}
                                                                size={40} />
                                                        </div>
                                                    }
                                                    <div className={`ticket_footer_button ${this.state.podeCancelar ? '' : 'ticket_footer_disabled'}`}>
                                                        <FontAwesomeIcon
                                                            title={this.state.podeCancelar ? 'Cancelar' : `Cancelamentos só podem ser processados entre ${this.state.dataCancelamentoComeco.format("HH:mm")} e ${this.state.dataCancelamentoFim.format("HH:mm")}`}
                                                            icon={faTimes}
                                                            color={"#DE3338"}
                                                            onClick={() => this.state.podeCancelar ? this.cancelVoucher(voucher.chave, voucher.unidadeNome) : this.setState({
                                                                alert: {
                                                                    type: 'error', msg: `Cancelamentos só podem ser processados entre ${this.state.dataCancelamentoComeco.format("HH:mm")} e ${this.state.dataCancelamentoFim.format("HH:mm")} `
                                                                }
                                                            })}
                                                            size={40} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                    </div>
                }
                <Footer selected="VOUCHERS" />
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        id: user.id,
        empresa: user.empresa,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(Vouchers)
